module.exports = __webpack_public_path__ + "static/img/logo.7b39f92c.png";